export enum LANGUAGE {
  KOREAN = "ko-KR",
  ENGLISH = "en-US",
}
